import React, { Component } from "react";

import DefaultHeader from "components/main/DefaultLayout/DefaultHeader";
import DefaultFooter from "components/main/DefaultLayout/DefaultFooter";

import stl from "./index.module.scss";
import BoardHeader from "../reference/Layout/ReferenceHeader";

class index extends Component {
	render() {
		return (
			<>
				<DefaultHeader headerNavLink = {'info'}/>
				<div id={stl.iconWrapper}>
					<div className={stl.iconContainer}>
						<span className={stl.title}>이용안내</span>
					</div>
				</div>
				<div id={stl.infoContainer}>
					{/*<img className={stl.infoTitle} alt="이용안내" src="/sis/images/main/info/infoBanner.png"/>*/}
					<div className={stl.infoWrapper}>	
						<img className={stl.userInfo} alt="이용안내" src="/sis/images/main/info/userInfo.png"/>
						{/*<img className={stl.userInfo} alt="이용안내" src="/sis/images/main/info/mapInfo.png"/>*/}
					</div>
				</div>
				<DefaultFooter />
			</>
		);
	}
}

export default index;
